import {identity, property} from "../voidash";
import TransformNode from "./TransformNode.js";

const getValue = property("value");

export default class SourceNode extends TransformNode {
  constructor(graph, value = null, pred = [], fn = identity) {
    super(graph, pred, fn);
    this.waitingValue = value;
    this.modifications = [];
    this.notifyChange();
  }

  get() {
    if (this.pred.length === 0 && this.fn === identity && this.modifications.length === 0) {
      return this.waitingValue;
    } else {
      return super.get();
    }
  }

  set(value) {
    if (this.waitingValue === value && value !== undefined) return;
    this.waitingValue = value;
    this.notifyChange();
  }

  trigger() {
    this.set(undefined);
  }

  modify(fn) {
    this.modifications.push(fn);
    this.notifyChange();
  }

  update() {
    let value = this.evaluate(this.waitingValue);
    this.modifications.forEach(fn => { value = this.evaluate(fn(value)); });
    this.modifications = [];
    this.value = this.waitingValue = value;
  }

  evaluate(value) {
    return this.fn(value, ...this.pred.map(getValue));
  }
}
